import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import { useParams } from "react-router-dom";
import "./UserPage.scss";
import Call from "./Call";

const UserPage = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [daysLeft, setDaysLeft] = useState(null);
  const urlHomepage = "users";
  const { id } = useParams();
  const triggerRedirect = React.useCallback(() => {
    window.location.replace("/login");
  }, []);
  const handleLogout = React.useCallback(() => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userProfile");
    triggerRedirect();
  }, [triggerRedirect]);

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    let redirectTimer;
    let tokenRemovalTimer;
    let isActive = true;

    const cleanup = () => {
      isActive = false;
      if (tokenRemovalTimer) {
        clearTimeout(tokenRemovalTimer);
      }
      if (redirectTimer) {
        clearTimeout(redirectTimer);
      }
    };

    if (!authToken) {
      setLoading(false);
      return cleanup;
    }

    const cachedUserRaw = localStorage.getItem("userProfile");
    if (cachedUserRaw) {
      try {
        const cachedUser = JSON.parse(cachedUserRaw);
        if (cachedUser?.id === getUserIdFromToken(authToken)) {
          setUser(cachedUser);
          setLoading(false);
        } else {
          localStorage.removeItem("userProfile");
        }
      } catch {
        localStorage.removeItem("userProfile");
      }
    }

    const fetchUser = async () => {
      try {
        const response = await axios.get(`${urlHomepage}/${id}`, {
          params: {
            fields: ["username", "tipProdus", "endDate"],
          },
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (!isActive) {
          return;
        }

        const userData = response.data;
        if (userData.id === getUserIdFromToken(authToken)) {
          setUser(userData);
          localStorage.setItem("userProfile", JSON.stringify(userData));
        } else {
          redirectTimer = setTimeout(triggerRedirect, 3000);
        }
      } catch (error) {
        if (isActive) {
          console.log("Error occurred while fetching user:", error);
        }
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };

    fetchUser();

    tokenRemovalTimer = setTimeout(() => {
      localStorage.removeItem("authToken");
      localStorage.removeItem("userProfile");
    }, 86400000);

    return cleanup;
  }, [id, triggerRedirect]);

  useEffect(() => {
    if (!user?.endDate) {
      setDaysLeft(null);
      return;
    }

    const endDate = new Date(user.endDate);
    if (Number.isNaN(endDate.getTime())) {
      setDaysLeft(null);
      return;
    }

    const diffInDays = Math.ceil(
      (endDate.getTime() - Date.now()) / (1000 * 60 * 60 * 24)
    );
    setDaysLeft(diffInDays);
  }, [user?.endDate]);

  useEffect(() => {
    if (daysLeft === null || daysLeft >= 1) {
      return;
    }

    const timer = setTimeout(triggerRedirect, 3000);

    return () => clearTimeout(timer);
  }, [daysLeft, triggerRedirect]);

  useEffect(() => {
    if (loading || user) {
      return;
    }

    const timer = setTimeout(triggerRedirect, 3000);

    return () => clearTimeout(timer);
  }, [loading, user, triggerRedirect]);

  const formattedDate = React.useMemo(() => {
    if (!user?.endDate) {
      return "";
    }

    const date = new Date(user.endDate);
    return Number.isNaN(date.getTime())
      ? ""
      : date.toLocaleDateString("ro-RO", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });
  }, [user?.endDate]);

  const getUserIdFromToken = (authToken) => {
    const tokenParts = authToken.split(".");
    if (tokenParts.length === 3) {
      const payload = JSON.parse(atob(tokenParts[1]));
      return payload.id;
    }
    return null;
  };

  if (loading) {
    return <h1>Loading...</h1>; // Show a loading message while fetching data
  }

  return (
    <div className="userPage_container">
      <div className="container">
        {user ? (
          <div className="userPage_detail_wrapper">
            <div className="photo"></div>
            <div className="userPage_infos">
              <h2>Bine ai venit, {user.username}!</h2>

              <div className="details">
                <h3>Mai jos regasesti informatii despre contul tau:</h3>
                <p>
                  Ai inchiriate urmatoarele:{" "}
                  <span className="dinamic_info">{user.tipProdus}</span>
                </p>
                <p>
                  Abonamentul expira in data de :{" "}
                  <span className="dinamic_info">{formattedDate || "---"}</span>
                  !
                </p>
                <p>
                  Mai ai{" "}
                  <span
                    className={`${
                      daysLeft !== null && daysLeft < 8 ? "red" : "normal"
                    } dinamic_info`}
                  >
                    {daysLeft ?? "--"}
                  </span>{" "}
                  zile abonamentul valabil!
                </p>
                <Call />
                <div className="disclaimer">
                  Pentru detalii si plati te rugam sa ne contactezi la{" "}
                  <a href="tel:0751996600" className="callAction_UserPage">
                    0751996600
                  </a>{" "}
                  sau completand formularul din sectiunea{" "}
                  <a href="/contact">Contact</a>!
                </div>
                <button
                  type="button"
                  className="logout_button"
                  onClick={handleLogout}
                >
                  Log out
                </button>
              </div>
            </div>
          </div>
        ) : (
          <h1>Accesul interzis. Vei fi redirectionat catre pagina de login!</h1>
        )}
      </div>
    </div>
  );
};

export default UserPage;
